"use client";
import React from 'react';
import Link from 'next/link';

type Group = { key: string; label: string; slug: string };

function makeGroups(): Group[] {
  const out: Group[] = [{ key: 'digits', label: '0-9', slug: '0-9' }];
  for (const L of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')) {
    out.push({ key: `${L}-a-j`, label: `${L}a-${L}j`, slug: `${L}a-${L}j`.toLowerCase() });
    out.push({ key: `${L}-k-z`, label: `${L}k-${L}z`, slug: `${L}k-${L}z`.toLowerCase() });
  }
  return out;
}
const GROUPS: Group[] = makeGroups();

export default function PeoplePrefixBrowser() {
  return (
    <div className="flex flex-wrap gap-2">
      {GROUPS.map((g) => (
        <Link
          key={g.key}
          href={`/sitemap/people/range/${encodeURIComponent(g.slug)}`}
          className="inline-flex items-center rounded border px-3 py-1 text-sm hover:bg-accent hover:text-accent-foreground"
        >
          {g.label}
        </Link>
      ))}
    </div>
  );
}
